import React from "react";
import { Navigate } from "react-router-dom";

// // Profile
import UserProfile from "../pages/Profile/UserProfile";

// // Authentication related pages
import Login from "../pages/Authentication/Login";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// // Pages General
import Dashboard from "../pages/Dashboard/index";
// // Services
import GeneralServices from "../pages/Services/GeneralServices.jsx";
import RequestServices from "../pages/Services/RequestServices";
import PreRequestServices from "../pages/Services/PreRequestServices.jsx";
import ExpressRequestService from "../pages/Services/ExpressRequestService";
import RouteRequestService from "../pages/Services/RouteRequestService/index.jsx";
import RequestService from "../pages/Services/RequestService";
import DetailService from "../pages/Services/DetailService/index.jsx";
import ServicesAssignment from "../pages/Services/ServicesAssignment";
import AssignService from "../pages/Services/AssignService";
import ReservationsServices from "../pages/Services/ReservationsServices";
import ReassignService from "../pages/Services/ReassignService";
import HistoricalServices from "../pages/Services/HistoricalServices";
import RescheduleService from "../pages/Services/RescheduleService/index.jsx";
import PreRequestService from "../pages/Services/PreRequestService/index.jsx";
import RoutingServices from "../pages/Services/RoutingServices/index.jsx";
// // Cost Centers
import CostCenters from "../pages/CostCenters/CostCenters";
import CostCenter from "../pages/CostCenters/CostCenter";
import NewCostCenter from "../pages/CostCenters/CreateCostCenter";
import EditCostCenter from "../pages/CostCenters/EditCostCenter";
import AssignSubAdmin from "../pages/CostCenters/AssignSubAdmin";
import ViewSubAdmins from "../pages/CostCenters/ViewSubadmins";
// // Employees
import AdminEmployees from "../pages/Employees/AdminEmployees";
import CreateEmployee from "../pages/Employees/CreateEmployee";
import EditEmployee from "../pages/Employees/EditEmployee";
// // Routing
import ModifyRouting from "../pages/Routing/ModifyRouting";
import GroupOriginRouting from "../pages/Routing/GroupOriginRouting";
import GroupDestinationRouting from "../pages/Routing/GroupDestinationRouting";
// // Chat
import Chat from "../pages/Communications/Chat";
// // Users
import AdminUsers from "../pages/Users/AdminUsers";
import CreateUser from "../pages/Users/CreateUser";
import EditUser from "../pages/Users/EditUser";
// // Bulk Schedule
import BulkScheduleWizard from "../pages/Services/BulkSchedule/index.jsx";
import BulkTaskList from "../pages/Services/BulkSchedule/list/BulkTaskList.jsx";
import BulkTaskDetail from "../pages/Services/BulkSchedule/list/BulkTaskDetail.jsx";
// // Control Tower
import ControlTowerMap from "../pages/ControlTower/ServicesMap";
import ControlTowerMapV2 from "../pages/ControlTower/ServicesMapV2";
// // Traccar
// import LoginTraccar from "../pages/LoginTraccar";

// //Pages
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/control-tower/services-map", component: <ControlTowerMap /> },
  { path: "/control-tower/services-map/v2", component: <ControlTowerMapV2 />},
  { path: "/control-tower/services-map/device/:deviceId", component: <ControlTowerMap /> },
  { path: "/services/general", component: <GeneralServices /> },
  { path: "/services/pre-request", component: <PreRequestServices /> },
  { path: "/services/request", component: <RequestServices /> },
  { path: "/services/request/:id", component: <DetailService /> },
  { path: "/services/request/reschedule", component: <RescheduleService />},
  { path: "/services/assignment/:id", component: <DetailService /> },
  { path: "/services/reservations/:id", component: <DetailService /> },
  { path: "/services/request/create", component: <RequestService /> },
  { path: "services/pre-request/create", component: <PreRequestService /> },
  { path: "services/express-request/create", component: <ExpressRequestService /> },
  { path: "services/route-request/create", component: <RouteRequestService />},
  { path: "/services/request/edit/:id", component: <RequestService /> },
  { path: "/services/reservations", component: <ReservationsServices /> },
  { path: "/services/historical", component: <HistoricalServices /> },
  { path: "/services/assignment", component: <ServicesAssignment /> },
  { path: "/services/assignment/create", component: <AssignService /> },
  { path: "/services/reassignment/:id", component: <ReassignService /> },
  { path: "/services/routing", component: <RoutingServices /> },
  { path: "/services/bulk-schedule", component: <BulkScheduleWizard /> },
  { path: "/services/bulk-schedule/tasks", component: <BulkTaskList /> },
  { path: "/services/bulk-schedule/tasks/:id", component: <BulkTaskDetail /> },
  { path: "/cost-centers", component: <CostCenters /> },
  { path: "/cost-centers/:id", component: <CostCenter /> },
  { path: "/cost-centers/new", component: <NewCostCenter /> },
  { path: "/cost-centers/edit/:id", component: <EditCostCenter /> },
  { path: "/cost-centers/sub-admin/:id", component: <AssignSubAdmin /> },
  { path: "/cost-centers/sub-admins/:id", component: <ViewSubAdmins /> },
  { path: "/employees", component: <AdminEmployees /> },
  { path: "/employees/create", component: <CreateEmployee /> },
  { path: "/employees/edit/:id", component: <EditEmployee /> },
  { path: "/routing/modify", component: <ModifyRouting /> },
  { path: "/routing/group-origin", component: <GroupOriginRouting /> },
  { path: "/routing/group-destination", component: <GroupDestinationRouting /> },
  { path: "/communications/chat", component: <Chat /> },
  { path: "/users", component: <AdminUsers /> },
  { path: "/users/create", component: <CreateUser /> },
  { path: "/users/edit/:id", component: <EditUser /> },
  // { path: "/login/traccar", component: <LoginTraccar /> },

  //   // //profile
  { path: "/profile", component: <UserProfile /> },

  //   // this route should be at the end of all other routes
  //   // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: <Navigate to="/services/request" /> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },

  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

];

// export { authProtectedRoutes, publicRoutes };
export { authProtectedRoutes, publicRoutes }
